import asyncComponent from "./hoc/asyncComponent";
import Carousel from "./Carousel";
import CarouselVertical from "./CarouselVertical";
import Collage from "./Collage";
import Empty from "./Empty";
import HTML from "./HTML";
import Img from "./Img";
import Lineal from "./Lineal";
import Text from "./Text";
import Video from "./Video";
import Bubbles from "./Bubbles";
import Cells from "./Cells";
import SocialWidget from "./SocialWidget";
import Svg from "./Svg";
import Link from "./Link";
import BackgroundImage from "./BackgroundImage";
import Arrow from "./Arrow";
import Message from "./Message";
import Counter from "./Counter";
import SlickCarousel from "./SlickCarousel";
import Tree from "./Tree";
import Div from "./Div";
import LayoutText from "./LayoutText";

const Leaking = asyncComponent(() => import("./Leaking"));

export default {
  Carousel,
  CarouselVertical,
  Collage,
  Empty,
  HTML,
  Img,
  Leaking,
  Lineal,
  Text,
  Video,
  Bubbles,
  Cells,
  SocialWidget,
  Svg,
  Link,
  BackgroundImage,
  Arrow,
  Message,
  Counter,
  SlickCarousel,
  Tree,
  Div,
  LayoutText,
};
